import { FormBase } from 'core/components';
import _ from 'lodash';

export default class OrderImportForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}

	setup() {
		return {
			fields: [
				{
					name: 'sellerId',
					label: 'ORDERVIEW.SELLER',
				},
			],
		};
	}

	options() {
		return {
			showErrorsOnReset: false,
		};
	}
}
